import { GroupNodeModel } from "@/models/nodes/GroupNodeModel";
import { InlineNodeModel } from "@/models/nodes/InlineNodeModel";

import type { NodeModel } from "@/models/nodes/types";
import type { VariableNodeModel } from "@/models/nodes/VariableNodeModel";

/** Turns `f(x, y)` back into `f` followed by a plain group holding the arguments. */
export function splitVariableArguments(node: VariableNodeModel) {
  const { doc, parameters, openingSymbol, closingSymbol } = node;
  const flattened = parameters.reduce<NodeModel[]>((acc, param) => [...acc, ...param.nodes], []);

  doc.transact(() => {
    const groupNode = doc.create(
      GroupNodeModel,
      flattened,
      openingSymbol ?? "(",
      closingSymbol ?? ")",
    );

    for (const param of parameters) {
      doc.removeNode(param);
    }

    node.insertSiblingAfter(groupNode);
  }, "splitVariableArguments");

  doc.cursor.moveTo(node.parent, node.index + 1);
}

/** Turns `f` followed by `(x)` into the function `f(x)`, consuming the group. */
export function mergeGroupIntoVariable(node: VariableNodeModel, group: GroupNodeModel) {
  const { doc } = node;

  doc.transact(() => {
    const nodes = group.inlineNode?.nodes ?? [];
    node.appendChild(doc.create(InlineNodeModel, nodes));

    node.openingSymbol = group.openingSymbol ?? "(";
    node.closingSymbol = group.closingSymbol ?? ")";

    doc.removeNode(group);
  }, "mergeGroupIntoVariable");
}
